export default "__VITE_ASSET__0dab1f17__"